import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { signInUrlTree } from 'app/core/auth/guards/sign-in-redirect';
import { UserService } from 'app/core/user/user.service';
import { map } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const userService = inject(UserService);
    const authService = inject(AuthService);

    // Check the authentication status
    return authService
        .check()
        .pipe(
            map((authenticated) => {
                // check() da true solo con el usuario cargado; si la sesión se
                // cerró entretanto, es un no autenticado. Se lee el usuario
                // directo: nada espera a user$ (issue #82).
                const user = userService.currentUser;

                // If the user is not authenticated...
                if (!authenticated || !user) {
                    // Al sign-in, con el destino en redirectURL
                    return signInUrlTree(router, state.url);
                }

                // Skip email verification check for the confirmation-required route
                if (state.url === '/confirmation-required') {
                    return true;
                }

                // If email is not verified, redirect to confirmation-required
                if (user.isEmailVerified === false) {
                    return router.parseUrl('/confirmation-required');
                }

                // Allow access if email is verified or verification status is unknown
                return true;
            })
        );
};
